import React from 'react';

function useBlurEffect(shouldWatch, callback, elementRef, parentRef) {
  React.useEffect(() => {
    if (!shouldWatch) {
      return undefined;
    }

    const handleDocumentClick = e => {
      const element = elementRef.current;
      const parent = parentRef === null || parentRef === void 0 ? void 0 : parentRef.current;
      const isElementOrContainedInElement = element ? element === e.target || element.contains(e.target) : false;
      const isParentOrContainedInParent = parent ? parent === e.target || parent.contains(e.target) : false;
      callback(isElementOrContainedInElement, isParentOrContainedInParent, e);
    };

    document.addEventListener('click', handleDocumentClick, true);
    return () => {
      document.removeEventListener('click', handleDocumentClick, true);
    };
  }, [shouldWatch, callback, elementRef, parentRef]);
}

export { useBlurEffect as default };
//# sourceMappingURL=useBlurEffect.js.map
